<p-toast></p-toast>
<div class="payment-method-outer">
    <div class="payment-method">
        <div class="payment-text">
            <p>List of added Parkers</p>
        </div>
        <div class="add-parker-outer">
            <p-button label="Add Parker" (onClick)="openAddParkerModal()"></p-button>
        </div>
    </div>
    </div>

<hr class="custom-border parker-border" />

<p-table class="parker-table-outer" #dt [value]="parkerList" dataKey="id" editMode="row" [tableStyle]="{ 'min-width': '50rem' }">

<ng-template pTemplate="body" let-product let-ri="rowIndex">
    <tr [pEditableRow]="product">

        <td class="vehicle-type">
            <div class="vic-type custom-veh-img">
                <div class="vic-text">
          
                    <div class="vehicle-outer">
                        <p-cellEditor>
                            <ng-template pTemplate="output">
                                <div class="driver-names">
                                        <img [src]="(product.profileImagePath)?product.profileImagePath:dummy" alt="" />
                                        <div class="vic-text">
                                            <p>First Name</p>
                                            <p class="truck-type">{{ product.firstName ? product.firstName : '-'}}</p>
                                        </div> 
                                   </div>
                            </ng-template>
                        </p-cellEditor>
                    </div>
                </div>
            </div>
        </td>
        <td>
            <div class="vic-type1">
                <div class="vic-text">
                    <p>Last Name</p>
                    <p-cellEditor>
                        <ng-template pTemplate="output">
                            <p class="truck-type">{{product.lastName || '-'}}</p>
                                            </ng-template>
                    </p-cellEditor>
                </div>
            </div>
        </td>
        <td>
            <div class="vic-type1">
                <div class="vic-text">
                    <p>Email</p>
                    <p-cellEditor>
                        <ng-template pTemplate="output">
                            <p class="truck-type">{{product.email || '-'}}</p>
                        </ng-template>
                    </p-cellEditor>
                </div>  
            </div>
        </td>
        <td>
            <div class="vic-type1">
                <div class="vic-text">
                    <p>Mobile Number</p>
                    <p-cellEditor>
                        <ng-template pTemplate="output">
                            <p class="mobile-number truck-type"><span *ngIf="product?.mobileNumber"
                                    [ngClass]="getFlagClass(product?.iso)"></span> {{ product.countryCode && product.mobileNumber ?
                                (product.countryCode + ' ' + product.mobileNumber) : '-' }}
                            </p>
                        </ng-template>
                    </p-cellEditor>
                </div>
            </div>
        </td>

        <td>
            <div class="action-item">
                <div class="export-btn">
                    <img (click)="activeItem = product;showData($event,product);menu.toggle($event)"
                        src="assets/images/dashboard-dot.svg" alt="" />
                </div>
            </div>
        </td>

    </tr>
</ng-template>

<ng-template pTemplate="emptymessage" let-columns>
    <tr class="no-inner">
      <td class="no-record" colspan="7">
        There are no Parkers added yet!
      </td>
    </tr>
  </ng-template>
</p-table>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu></div>